import { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { Euro, Truck, BadgePercent, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ClinicTariffs({ me }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/tariffs"); setItems(data); }
      catch (e) { toast.error(apiError(e)); }
      finally { setLoading(false); }
    })();
  }, []);

  const travel = Number(me?.travel_cost || 0);
  const discount = Number(me?.discount_percent || 0);
  const discountNote = me?.discount_note || "";
  const hasDiscount = discount > 0;
  const disc = (p) => p * (1 - discount / 100);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#7FD498]" /></div>;

  return (
    <div className="space-y-4" data-testid="clinic-tariffs">
      {hasDiscount && (
        <div className="bg-[#7FD498]/15 border border-[#7FD498] rounded-2xl p-4 flex items-start gap-3" data-testid="clinic-discount-banner">
          <div className="h-10 w-10 rounded-xl bg-[#7FD498]/30 flex items-center justify-center shrink-0"><BadgePercent className="h-5 w-5 text-[#2f7a45]" /></div>
          <div>
            <p className="font-bold text-[#373E45]">Descuento promocional: {discount % 1 === 0 ? discount : discount.toFixed(2)}%</p>
            {discountNote && <p className="text-sm text-[#5a8a68] mt-0.5">{discountNote}</p>}
          </div>
        </div>
      )}

      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div className="px-5 py-4 border-b border-slate-100 flex items-center gap-2">
          <Euro className="h-5 w-5 text-[#7FD498]" />
          <h3 className="font-bold text-[#373E45]">Tarifas de estudios</h3>
        </div>
        {items.length === 0 ? (
          <p className="text-sm text-[#64748B] p-5">Aún no hay tarifas publicadas. Consúltanos para más información.</p>
        ) : (
          <div className="divide-y divide-slate-100">
            {items.map((t) => (
              <div key={t.id} className="px-5 py-3.5 flex items-start justify-between gap-4" data-testid={`clinic-tariff-${t.id}`}>
                <div className="min-w-0">
                  <p className="font-semibold text-[#373E45]">{t.name}</p>
                  {t.description && <p className="text-xs text-[#64748B]">{t.description}</p>}
                </div>
                <div className="text-right shrink-0">
                  {hasDiscount ? (
                    <>
                      <span className="text-sm text-slate-400 line-through mr-2">{t.price.toFixed(2)} €</span>
                      <span className="font-extrabold text-[#2f7a45]" data-testid={`clinic-tariff-final-${t.id}`}>{disc(t.price).toFixed(2)} €</span>
                    </>
                  ) : (
                    <span className="font-extrabold text-[#373E45]">{t.price.toFixed(2)} €</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="px-5 py-3.5 border-t border-slate-100 flex items-center justify-between bg-slate-50" data-testid="clinic-travel-cost">
          <span className="font-semibold text-[#373E45] flex items-center gap-2"><Truck className="h-4 w-4 text-[#9DC3E6]" />Coste de desplazamiento</span>
          <span className="font-extrabold text-[#373E45]">{travel.toFixed(2)} €</span>
        </div>
      </div>

      <p className="text-xs text-slate-400 px-1">Los precios indicados no incluyen IVA (21%).</p>
    </div>
  );
}
